import uuid5 from 'uuid/v5';
import uuid4 from 'uuid/v4';
import { updateAccount } from '../actions/history-actions';
// const uuid5 = require('uuid/v5');
// const uuid4 = require('uuid/v4');
import { ASSETS_TYPE, LIABILITIES_TYPE } from './templateHistoryTypes';

export class HistoryItem {
  constructor(selectedGroup = null) {
    const today = new Date();
    this.selectedGroup = selectedGroup;
    this.mulitplier = 1;

    this.year = today.getFullYear();
    this.month = today.getMonth() + 1;
    this.day = today.getDate();
    this.assets = [];
    this.liabilities = [];
    this.balance = 0;
  }

  clone() {
    return Object.assign(new HistoryItem(this.selectedGroup), this.serialize());
  }

  cloneToDate({ day, month, year }) {
    const historyItem = this.clone();
    historyItem.day = day;
    historyItem.month = month;
    historyItem.year = year;
    historyItem.createdAt = new Date();
    historyItem.updatedAt = new Date();
    historyItem._id = uuid5(uuid4(), uuid5.URL);
    delete historyItem._rev;

    return historyItem;
  }

  findGroupById(groupId) {
    return this.findAssetGroupById(groupId) || this.findLiabilitiesGroupById(groupId);
  }

  deleteAssetGroup(groupId) {
    this.findGroupById(groupId);
    const groupIndex = this.assets.map(group => group._id).indexOf(this.selectedGroup._id);
    this.assets.splice(groupIndex, 1);
  }

  deleteLiabilitiesGroup(groupId) {
    this.findGroupById(groupId);
    const groupIndex = this.liabilities.map(group => group._id).indexOf(this.selectedGroup._id);
    this.liabilities.splice(groupIndex, 1);
  }

  updateAccount(groupId, updatedAccount) {
    this.findGroupById(groupId);
    this.selectedGroup.accounts.forEach((account, idx) => {
      if (account._id === updatedAccount._id) {
        this.selectedGroup.accounts[idx] = updatedAccount;
      }
    });

    this.recalculateBalance();

    return this;
  }

  updateGroupName (groupId, groupName) {
    this.findGroupById(groupId);
    this.selectedGroup.groupName = groupName
  }

  deleteAccount(groupId, accountId) {
    this.findGroupById(groupId);
    const accountIndex = this.selectedGroup.accounts.map(account => account._id).indexOf(accountId);

    this.selectedGroup.accounts.splice(accountIndex, 1);

    this.recalculateBalance();

    return this;
  }

  assetGroup(groupName, ignoreName = false) {
    this.mulitplier = 1;
    if (!ignoreName) {
      for (let i = 0; i < this.assets.length; i += 1) {
        const group = this.assets[i];
        if (group.groupName === groupName) {
          this.selectedGroup = group;
          return this;
        }
      }
    }

    const newGroup = {
      _id: uuid5(uuid4(), uuid5.URL),
      groupName,
      accounts: [],
      balance: 0,
    };
    this.selectedGroup = newGroup;

    this.assets.push(newGroup);

    return this;
  }

  findAssetGroupById(groupId) {
    this.mulitplier = 1;
    for (let i = 0; i < this.assets.length; i += 1) {
      const group = this.assets[i];
      if (group._id === groupId) {
        this.selectedGroup = group;
        return this;
      }
    }
  }

  liabilitiesGroup(groupName, ignoreName = false) {
    this.mulitplier = 1;
    if (!ignoreName) {
      for (let i = 0; i < this.liabilities.length; i += 1) {
        const group = this.liabilities[i];
        if (group.groupName === groupName) {
          this.selectedGroup = group;
          return this;
        }
      }
    }

    const newGroup = {
      _id: uuid5(uuid4(), uuid5.URL),
      groupName,
      accounts: [],
      balance: 0,
    };
    this.selectedGroup = newGroup;

    this.liabilities.push(newGroup);

    return this;
  }

  findLiabilitiesGroupById(groupId) {
    this.mulitplier = 1;
    for (let i = 0; i < this.liabilities.length; i += 1) {
      const group = this.liabilities[i];
      if (group._id === groupId) {
        this.selectedGroup = group;
        return this;
      }
    }
  }

  removeAccount(accountId) {

  }

  addBankAccount(accountName, balance) {
    this.addAccount(accountName, balance, 'current', 'GBP');
    return this;
  }

  addGenericAccount(accountName, balance) {
    this.addAccount(accountName, balance, 'generic', 'GBP');
    return this;
  }

  addCar(accountName, balance, minValue, monthlyDepreciation) {
    this.addAccount(accountName, balance, 'car', 'GBP', {
      minValue,
      monthlyDepreciation,
    });
    return this;
  }

  addAccount(accountName, balance, accountType, currency, options = {}) {
    const multiBalance = balance * this.mulitplier * 100;
    this.selectedGroup.accounts.push({
      _id: uuid5(uuid4(), uuid5.URL),
      accountName,
      accountType,
      currency,
      balance: multiBalance,
      ...options,
    });

    this.recalculateBalance();

    return this;
  }

  recalculateBalance() {
    this.balance = 0;
    this.assets.forEach((group, idx) => {
      this.assets[idx].balance = group.accounts.reduce((total, account) => total + account.balance, 0);
      this.balance += this.assets[idx].balance;
    });


    this.liabilities.forEach((group, idx) => {
      this.liabilities[idx].balance = group.accounts.reduce((total, account) => total + account.balance, 0);
      this.balance -= this.liabilities[idx].balance;
    });
  }

  static deserialize(rawObj) {
    const newObj = JSON.parse(JSON.stringify(rawObj));

    const deserializeAccount = (account) => {
      const newAccount = Object.assign({}, account);
      newAccount.balance = parseInt(newAccount.balance, 10);
      return newAccount;
    };

    const deserializeGroup = (group) => {
      const newGroup = Object.assign({}, group);
      newGroup.balance = parseInt(newGroup.balance, 10);
      newGroup.accounts = newGroup.accounts.map(deserializeAccount);

      return newGroup;
    };

    newObj.assets = newObj.assets.map(deserializeGroup);
    newObj.liabilities = newObj.liabilities.map(deserializeGroup);
    newObj.balance = parseInt(newObj.balance, 10);

    return Object.assign(new HistoryItem(), newObj);
  }

  serialize() {
    const serializeAccount = (account) => {
      const newAccount = Object.assign({}, account);
      newAccount.balance = `${newAccount.balance}`;
      return newAccount;
    };

    const serializeGroup = (group) => {
      const newGroup = Object.assign({}, group);
      newGroup.balance = `${newGroup.balance}`;
      newGroup.accounts = newGroup.accounts.map(serializeAccount);

      return newGroup;
    };

    const newObj = Object.assign({}, this);
    newObj.assets = newObj.assets.map(serializeGroup);
    newObj.liabilities = newObj.liabilities.map(serializeGroup);
    newObj.balance = `${newObj.balance}`;

    return newObj;
  }
}

// istanciates the class into an object and runs the constructor
// this sets up our history item (state)


// TODO: BY YOU NEED TO EXPORT THIS - export const defaultTemplate
export const defaultTemplate = new HistoryItem();

// Call method assetGroup on defaultTemplate,
defaultTemplate.assetGroup('Cash and Bank Accounts')
  .addBankAccount('Current Account', 1000)
  .addBankAccount('Savings Account', 250);

defaultTemplate.assetGroup('Investments')
  .addGenericAccount('House (2 Privet Drive)', 250000)
  .addGenericAccount('Help-to-buy ISA', 200)
  .addGenericAccount('Stocks and Shares ISA', 5000);

defaultTemplate.assetGroup('Other Assets')
  .addCar('Fiat car', 10890.9, 500, 181.5);

defaultTemplate.liabilitiesGroup('Mortgage')
  .addGenericAccount('LloydTSB (2 Privet Drive)', 220000);


// console.log(JSON.stringify(defaultTemplate.serialize(), null, '  '));



// WEBPACK FOOTER //
// ./src/utils/templateHistory.js